import ApplicationAdapter from './application';

export default class extends ApplicationAdapter {
  coalesceFindRequests = true;
}
